import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (to.name === 'no_accounts' || !to.name) {
    return next(frontendURL(`accounts/${accountId}/home`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

// Maps each section to the stores that should be cleaned when ENTERING that section.
// Stores from the previous section are released to free memory.
const SECTION_CLEANUP = {
  conversations: ['deals', 'pipelines', 'products', 'reports', 'contacts'],
  crm: ['reports', 'conversationSearch'],
  reports: ['deals', 'products', 'pipelines', 'conversationSearch', 'contacts'],
  captain: ['deals', 'reports', 'products', 'pipelines', 'contacts'],
  social: ['deals', 'reports', 'products', 'pipelines', 'contacts'],
  settings: ['deals', 'reports', 'conversationSearch', 'contacts'],
  home: ['deals', 'reports', 'products', 'pipelines', 'contacts'],
};

function getSection(path) {
  if (path.includes('/conversations') || path.includes('/inbox/')) {
    return 'conversations';
  }
  // Check /crm before /reports since both could match different parts
  if (path.includes('/crm')) return 'crm';
  if (path.includes('/social')) return 'social';
  if (path.includes('/reports')) return 'reports';
  if (path.includes('/captain')) return 'captain';
  if (path.includes('/settings')) return 'settings';
  if (path.includes('/home')) return 'home';
  return null;
}

// Aba aberta ANTES de um deploy pede o pedaco antigo de uma tela, que nao
// existe mais no servidor. O recarregamento generico (vite:preloadError, no
// entrypoint) voltava pra pagina ATUAL — a pessoa clicava em Tickets e "nada
// acontecia"; so o segundo clique abria. Aqui recarrega ja no DESTINO.
const ERRO_DE_PEDACO_DA_TELA =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i;

router.onError((error, to) => {
  if (!ERRO_DE_PEDACO_DA_TELA.test(error?.message || '') || !to?.fullPath) {
    return;
  }
  window.smartRecarregandoNoDestino = true;
  window.location.assign(to.fullPath);
});

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    // Cleanup stores when switching between major sections
    const fromSection = getSection(from.path);
    const toSection = getSection(to.path);
    if (fromSection && toSection && fromSection !== toSection) {
      const storesToClean = SECTION_CLEANUP[toSection] || [];
      storesToClean.forEach(storeName => {
        try {
          if (storeName === 'conversationSearch') {
            store.dispatch('conversationSearch/clearSearchResults');
          } else {
            store.dispatch(`${storeName}/resetStore`);
          }
        } catch {
          // Store may not have the action — safe to ignore
        }
      });
    }

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
